"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (input) {
	return typeof input.isPaused === "function" && typeof input.pause === "function" && typeof input.pipe === "function" && typeof input.read === "function" && typeof input.resume === "function" && typeof input.setEncoding === "function" && typeof input.unpipe === "function" && typeof input.unshift === "function" && typeof input.wrap === "function";
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-raw-html/build/isReadableStream.js
// module id = 1380
// module chunks = 0